import { render, staticRenderFns } from "./EmailConfig.vue?vue&type=template&id=42e3c61a&scoped=true"
import script from "./EmailConfig.vue?vue&type=script&lang=js"
export * from "./EmailConfig.vue?vue&type=script&lang=js"
import style0 from "./EmailConfig.vue?vue&type=style&index=0&id=42e3c61a&prod&lang=scss&scoped=true"
import style1 from "./EmailConfig.vue?vue&type=style&index=1&id=42e3c61a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e3c61a",
  null
  
)

export default component.exports